import { styled } from 'styled-components'

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.grayAccent};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Container = styled.div`
  width: 334px;
  height: 428px;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  margin-bottom: 36px;
`

export const Title = styled.span`
  width: 306px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  line-height: 110%; /* 28.6px */
  text-transform: capitalize;
`

export const Subtitle = styled.span`
  width: 268px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 120%; /* 21.6px */
`

export const Thumbnail = styled.img`
  width: 120px;
  height: 120px;
  padding: 24px;
  margin-top: 16px;
`
